import React, { createContext } from "react";
import { PortfolioTab } from "@shared/types";

export const PortfolioContext = createContext<
  | {
      isPositions: boolean;
      isCardsView: boolean;
      setIsCardsView: (isCardsView: boolean) => void;
      searchValue: string;
      setSearchValue: (searchValue: string) => void;
      buyModalOpen: boolean;
      setBuyModalOpen: (buyModalOpen: boolean) => void;
      loading: boolean;
      loaded: boolean;
      selectedTab: PortfolioTab;
      setSelectedTab: (tab: PortfolioTab) => void;
      tabToNumItems: Record<PortfolioTab, number | undefined>;
      setTabToNumItems: React.Dispatch<
        React.SetStateAction<Record<PortfolioTab, number | undefined>>
      >;
    }
  | undefined
>(undefined);
